import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { InputText } from 'primereact/inputtext'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDebouncedCallback } from 'use-debounce'

interface ApiSearchInputProps {
  apiSearchInput?: string
}

export const ApiSearchInput = ({ apiSearchInput }: ApiSearchInputProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const urlSearchParams = new URLSearchParams(window.location.search)

  const searchDebounce = useDebouncedCallback((value: string) => {
    if (value) {
      urlSearchParams.set('search', value)
      urlSearchParams.set('offset', '0')
    } else {
      urlSearchParams.delete('search')
      urlSearchParams.set('offset', '0')
    }

    const newSearch = urlSearchParams.toString()
    history.push({
      pathname: window.location.pathname,
      search: decodeURIComponent(newSearch),
    })
  }, 1000)

  return (
    <span className="p-input-icon-left border-round p-input-icon-right">
      <FontAwesomeIcon icon={'search'} />
      <InputText
        defaultValue={apiSearchInput}
        onChange={e => searchDebounce(e.target.value)}
        placeholder={t('Keyword Search')}
      />
    </span>
  )
}
